/**
 * Language switch, in the header on every screen.
 *
 * Shows the language a tap switches *to*, which is the convention donors
 * already meet on Pakistani banking apps: reading "اردو" means "give me
 * Urdu", not "you are in Urdu".
 */

import { memo } from 'react';
import { Pressable, StyleSheet } from 'react-native';

import { colors, radius, space } from '../../theme';
import { LANGUAGE_LABEL, LANGUAGE_SHORT, otherLanguage } from '../../core/i18n/language';
import { useLanguage } from '../../core/i18n/LanguageProvider';
import { Text } from '../common/Text';

export const LanguageToggle = memo(function LanguageToggle() {
  const { language, toggleLanguage } = useLanguage();
  const next = otherLanguage(language);

  return (
    <Pressable
      onPress={toggleLanguage}
      accessibilityRole="button"
      accessibilityLabel={`Switch to ${LANGUAGE_LABEL[next]}`}
      style={styles.button}
      testID="language-toggle"
    >
      <Text variant="badge" tone="brand">
        {LANGUAGE_SHORT[next]}
      </Text>
    </Pressable>
  );
});

const styles = StyleSheet.create({
  button: {
    minWidth: 44,
    height: 32,
    paddingHorizontal: space.sm,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: radius.full,
    borderWidth: 1,
    borderColor: colors.border.default,
    backgroundColor: colors.bg.brandSubtle,
  },
});
